
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "open_fractrue",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/open_fractrue.vue